import { Stack, TextField, Typography } from '@mui/material'
import type { FC } from 'react'
import { semanticColors } from '../theme/semanticColors'
import type { useFormikProps } from './EditPlaceGroup.hooks'

type TProps = Pick<
  ReturnType<typeof useFormikProps>,
  'handleChange' | 'values' | 'errors'
>

const NameRow: FC<TProps> = ({ handleChange, values, errors }) => {
  return (
    <Stack>
      <Typography variant="subtitle1" mb={1}>
        現場グループ名
      </Typography>
      <TextField
        fullWidth
        size="medium"
        onChange={handleChange('name')}
        value={values.name}
        error={Boolean(errors.name)}
        slotProps={{ htmlInput: { maxLength: 255 } }}
      />
      {errors.name && (
        <Typography variant="body1" color={semanticColors.colorErrorText}>
          {errors.name}
        </Typography>
      )}
    </Stack>
  )
}

export default NameRow
